import React, { useState } from "react";
//import { useHistory } from "react-router-dom";
import { TableContext } from "../../../index";
import { debug } from "../../../utils";
import PortsTable from "./PortsTable";


function PortsCard({ data }) {

    //const history = useHistory();
    const initTableConfig = {
        selected: [],
        //showModal: handleShowModal
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <div>
            <div className="card">
                <div className="card-body-uc">
                <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
                    <PortsTable portsList={data} /> 
                </TableContext.Provider>
                </div>
            </div>
        </div>

    )

 
    // return (
    //     <>
    //         <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
    //             <div className="container-fluid" key={history.location}>
    //                 <div className="row">
    //                     <div className="col-12">
    //                         <div className="card oct_table-card">
    //                             <div className="card-body">
    //                                 <div className="dataTables_wrapper dt-bootstrap4 no-footer">
    //                                     <div className="row">
    //                                         <div className="col-sm-12">
    //                                             <PortsTable portsList={data} />                                               
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </TableContext.Provider>
    //     </>
    // )
}

// function mapStateToProps(state) {
//     debug("VulscanScheduleCard mapStateToProps:", state);
//     const validation = state.validation;
//     const loggedUserId = state.auth.id || null;
//     return {
//         errors: validation || {},
//         loggedUserId: loggedUserId
//     }
// }

//export default connect(mapStateToProps)(VulscanScheduleCard);
export default PortsCard;
